<template>
  <svg
    v-if="icon"
    xmlns="http://www.w3.org/2000/svg"
    :width="iconData.width"
    :height="iconData.height"
    :viewBox="iconData.viewBox"
    :aria-labelledby="`${iconData.name.replace(' ', '-')}-icon`"
    role="presentation"
  >

    <title :id="`${iconData.name.replace(' ', '-')}-icon`">{{ iconData.name }}</title>

    <g :style="{ 'fill': 'currentColor' }">
      <component :is="icon" />
    </g>
  </svg>
</template>

<script>
// Import SVGs here
const ArrowNext = () => import('@/components/base/svg/elements/ArrowNext.vue');
const ArrowPrev = () => import('@/components/base/svg/elements/ArrowPrev.vue');
const BtnLoading = () => import('@/components/base/svg/elements/BtnLoading.vue');
const BarCode = () => import('@/components/base/svg/elements/BarCode.vue');
const Book = () => import('@/components/base/svg/elements/Book.vue');
const Close = () => import('@/components/base/svg/elements/Close.vue');
const Check = () => import('@/components/base/svg/elements/Check.vue');
const Graphic = () => import('@/components/base/svg/elements/Graphic.vue');
const Logout = () => import('@/components/base/svg/elements/Logout.vue');
const LogoPrefeiturapmvv = () => import('@/assets/theme/pmvv/icons/LogoPrefeitura.vue');
const LogoPrefeiturapmcariacica = () => import('@/assets/theme/pmcariacica/icons/LogoPrefeitura.vue');
const LogoPrefeituraupcities = () => import('@/assets/theme/upcities/icons/LogoPrefeitura.vue');
const LogoPrefeiturapmci = () => import('@/assets/theme/pmci/icons/LogoPrefeitura.vue');
const LogoPrefeiturapmvvWhite = () => import('@/assets/theme/pmvv/icons/LogoPrefeituraWhite.vue');
const LogoPrefeiturapmcariacicaWhite = () => import('@/assets/theme/pmcariacica/icons/LogoPrefeituraWhite.vue');
const LogoPrefeituraupcitiesWhite = () => import('@/assets/theme/upcities/icons/LogoPrefeituraWhite.vue');
const LogoPrefeiturapmciWhite = () => import('@/assets/theme/pmci/icons/LogoPrefeituraWhite.vue');
const ConsultarAgendamento = () => import('@/components/base/svg/elements/ConsultarAgendamento.vue');
const Warning = () => import('@/components/base/svg/elements/Warning.vue');
const ArrowRight = () => import('@/components/base/svg/elements/ArrowRight.vue');
const ConfirmAppointment = () => import('@/components/base/svg/elements/ConfirmAppointment.vue');
const ArrowStepper = () => import('@/components/base/svg/elements/ArrowStepper.vue');
const Question = () => import('@/components/base/svg/elements/Question.vue');
const Dash = () => import('@/components/base/svg/elements/Dash.vue');
const Search = () => import('@/components/base/svg/elements/Search.vue');
const WomanIllustration = () => import('@/components/base/svg/elements/WomanIllustration.vue');
const SignsIllustration = () => import('@/components/base/svg/elements/SignsIllustration.vue');
const SignsIllustrationMobile = () => import('@/components/base/svg/elements/SignsIllustrationMobile.vue');
const ExternalLink = () => import('@/components/base/svg/elements/ExternalLink.vue');
const FilterSvg = () => import('@/components/base/svg/elements/FilterSvg.vue');
const Account = () => import('@/components/base/svg/elements/Account.vue');
const FAQ = () => import('@/components/base/svg/elements/FAQ.vue');
const Instagram = () => import('@/components/base/svg/elements/Instagram.vue');
const Youtube = () => import('@/components/base/svg/elements/Youtube.vue');
const Linkedin = () => import('@/components/base/svg/elements/Linkedin.vue');
const Facebook = () => import('@/components/base/svg/elements/Facebook.vue');
const Web = () => import('@/components/base/svg/elements/IconWeb.vue');
const Cellphone = () => import('@/components/base/svg/elements/Cellphone.vue');
const LogoUpcitiesWhite = () => import('@/components/base/svg/elements/LogoUpcitiesWhite.vue');
const Email = () => import('@/components/base/svg/elements/Email.vue');
const NovaReclamacaoBg = () => import('@/components/base/svg/elements/NovaReclamacaoBg.vue');
const Clip = () => import('@/components/base/svg/elements/Clip.vue');
const CircleClip = () => import('@/components/base/svg/elements/CircleClip.vue');
const IcAdd = () => import('@/components/base/svg/elements/IcAdd.vue');
const IcCheck = () => import('@/components/base/svg/elements/IcCheck.vue');
const Trash = () => import('@/components/base/svg/elements/Trash.vue');
const PdfImg = () => import('@/components/base/svg/elements/PdfImg.vue');
const ConfirmData = () => import('@/components/base/svg/elements/ConfirmData.vue');
const CircleDocument = () => import('@/components/base/svg/elements/CircleDocument.vue');
const UserFinish = () => import('@/components/base/svg/elements/UserFinish.vue');
const DocumentsFinish = () => import('@/components/base/svg/elements/DocumentsFinish.vue');
const ClipFinish = () => import('@/components/base/svg/elements/ClipFinish.vue');
const EyeSolid = () => import('@/components/base/svg/elements/EyeSolid.vue');
const Descricao = () => import('@/components/base/svg/elements/Descricao.vue');
const Download = () => import('@/components/base/svg/elements/Download.vue');
const Play = () => import('@/components/base/svg/elements/Play.vue');
const Pause = () => import('@/components/base/svg/elements/Pause.vue');
const Dislike = () => import('@/components/base/svg/elements/Dislike.vue');
const Clock = () => import('@/components/base/svg/elements/Clock.vue');
const Redirect = () => import('@/components/base/svg/elements/Redirect.vue');
const OnboardingAvatar = () => import('@/components/base/svg/elements/OnboardingAvatar.vue');
const Balloon = () => import('@/components/base/svg/elements/Balloon.vue');
const IlustracaoErro = () => import('@/components/base/svg/elements/IlustracaoErro.vue');
const Imprimir = () => import('@/components/base/svg/elements/Imprimir.vue');
const Info = () => import('@/components/base/svg/elements/Info.vue');
const Compartilhar = () => import('@/components/base/svg/elements/Compartilhar.vue');
const CopyLink = () => import('@/components/base/svg/elements/CopyLink.vue');
const FacebookShare = () => import('@/components/base/svg/elements/FacebookShare.vue');
const WhatsappShare = () => import('@/components/base/svg/elements/WhatsappShare.vue');
const TwitterShare = () => import('@/components/base/svg/elements/TwitterShare.vue');
const Backspace = () => import('@/components/base/svg/elements/Backspace.vue');
const Endereco = () => import('@/components/base/svg/elements/Endereco.vue');
const InformacoesAdicionais = () => import('@/components/base/svg/elements/InformacoesAdicionais.vue');
const Files = () => import('@/components/base/svg/elements/Files.vue');
const FormDescription = () => import('@/components/base/svg/elements/FormDescription.vue');
const MultiFile = () => import('@/components/base/svg/elements/MultiFile.vue');
const Confirm = () => import('@/components/base/svg/elements/Confirm.vue');
const Copy = () => import('@/components/base/svg/elements/Copy.vue');
const ModalIllustrationError = () => import('@/components/base/svg/elements/ModalIllustrationError.vue');
const IconEdit = () => import('@/components/base/svg/elements/IconEdit.vue');
const IconUser = () => import('@/components/base/svg/elements/IconUser.vue');
const IconPhone = () => import('@/components/base/svg/elements/IconPhone.vue');
const IconId = () => import('@/components/base/svg/elements/IconId.vue');
const IconMail = () => import('@/components/base/svg/elements/IconMail.vue');
const WarningTriangle = () => import('@/components/base/svg/elements/WarningTriangle.vue');
const FileDoc = () => import('@/components/base/svg/elements/IconFileDoc.vue');
const FileImg = () => import('@/components/base/svg/elements/IconFileImg.vue');
const FileLimite = () => import('@/components/base/svg/elements/IconFileLimite.vue');
const FilePdf = () => import('@/components/base/svg/elements/IconFilePdf.vue');
const Mais = () => import('@/components/base/svg/elements/Mais.vue');
const LockSolid = () => import('@/components/base/svg/elements/LockSolid.vue');
const HistoricoAnexos = () => import('@/components/base/svg/elements/HistoricoAnexos.vue');
const Excluir = () => import('@/components/base/svg/elements/Excluir.vue');
const Comentar = () => import('@/components/base/svg/elements/Comentar.vue');
const Detalhes = () => import('@/components/base/svg/elements/Detalhes.vue');
const DadosSolicitacao = () => import('@/components/base/svg/elements/DadosSolicitacao.vue');
const Feedback = () => import('@/components/base/svg/elements/Feedback.vue');
const SurveyLogo = () => import('@/components/base/svg/elements/SurveyLogo.vue');
const RatingStar = () => import('@/components/base/svg/elements/RatingStar.vue');
const Represented = () => import('@/components/base/svg/elements/Represented.vue');

export default {
  name: 'SvgBase',

  components: {
    // Load them here
    ArrowNext,
    ArrowPrev,
    BtnLoading,
    BarCode,
    Book,
    Close,
    Check,
    Graphic,
    Logout,
    LogoPrefeiturapmvv,
    LogoPrefeiturapmcariacica,
    LogoPrefeituraupcities,
    LogoPrefeiturapmci,
    LogoPrefeiturapmvvWhite,
    LogoPrefeiturapmcariacicaWhite,
    LogoPrefeituraupcitiesWhite,
    LogoPrefeiturapmciWhite,
    ConsultarAgendamento,
    Warning,
    ArrowRight,
    ConfirmAppointment,
    ArrowStepper,
    Question,
    Dash,
    Search,
    WomanIllustration,
    SignsIllustration,
    SignsIllustrationMobile,
    ExternalLink,
    FilterSvg,
    Account,
    FAQ,
    Instagram,
    Youtube,
    Linkedin,
    Facebook,
    Web,
    Cellphone,
    LogoUpcitiesWhite,
    Email,
    NovaReclamacaoBg,
    Clip,
    CircleClip,
    IcAdd,
    IcCheck,
    Trash,
    PdfImg,
    ConfirmData,
    CircleDocument,
    UserFinish,
    DocumentsFinish,
    ClipFinish,
    EyeSolid,
    Descricao,
    Download,
    Play,
    Pause,
    Dislike,
    Clock,
    Redirect,
    OnboardingAvatar,
    Balloon,
    IlustracaoErro,
    Imprimir,
    Info,
    Compartilhar,
    CopyLink,
    FacebookShare,
    WhatsappShare,
    TwitterShare,
    Backspace,
    Endereco,
    InformacoesAdicionais,
    Files,
    FormDescription,
    MultiFile,
    Confirm,
    Copy,
    ModalIllustrationError,
    IconEdit,
    IconUser,
    IconId,
    IconPhone,
    IconMail,
    WarningTriangle,
    FileDoc,
    FileImg,
    FileLimite,
    FilePdf,
    Mais,
    LockSolid,
    HistoricoAnexos,
    Excluir,
    Comentar,
    Detalhes,
    DadosSolicitacao,
    Feedback,
    SurveyLogo,
    RatingStar,
    Represented,
  },

  props: {
    icon: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: false,
      default: null,
    },
    width: {
      type: [Number, String],
      required: false,
      default: null,
    },
    height: {
      type: [Number, String],
      required: false,
      default: null,
    },
    viewBox: {
      type: String,
      required: false,
      default: null,
    },
  },

  computed: {
    iconData() {
      switch (this.icon) {
        case 'ArrowNext':
          return this.defaultData('23', '17');
        case 'ArrowPrev':
          return this.defaultData('23', '17');
        case 'BtnLoading':
          return this.defaultData('16', '16', '0 0 128 128');
        case 'Check':
          return this.defaultData('59', '59');
        case 'Close':
          return this.defaultData('17', '17');
        case 'Logout':
          return this.defaultData('21');
        case 'ConsultarAgendamento':
          return this.defaultData('70', '70');
        case 'Warning':
          return this.defaultData('20', '20');
        case 'ArrowRight':
          return this.defaultData('9', '14');
        case 'ConfirmAppointment':
          return this.defaultData('59', '59');
        case 'ArrowStepper':
          return this.defaultData('11', '6');
        case 'Question':
          return this.defaultData('60', '60');
        case 'Dash':
          return this.defaultData('11', '6');
        case 'Search':
          return this.defaultData('15', '15');
        case 'LogoPrefeiturapmcariacica':
          return this.defaultData('141', '40');
        case 'LogoPrefeiturapmvv':
          return this.defaultData('120', '33');
        case 'LogoPrefeituraupcities':
          return this.defaultData('142', '76');
        case 'LogoPrefeiturapmci':
          return this.defaultData('425', '133');
        case 'LogoPrefeiturapmcariacicaWhite':
          return this.defaultData('139', '40');
        case 'LogoPrefeiturapmvvWhite':
          return this.defaultData('166', '44');
        case 'LogoPrefeituraupcitiesWhite':
          return this.defaultData('142', '76');
        case 'LogoPrefeiturapmciWhite':
          return this.defaultData('425', '133');
        case 'WomanIllustration':
          return this.defaultData('540', '540');
        case 'SignsIllustration':
          return this.defaultData('480', '440');
        case 'SignsIllustrationMobile':
          return this.defaultData('270', '240');
        case 'ExternalLink':
          return this.defaultData('14', '14');
        case 'FilterSvg':
          return this.defaultData('16', '16');
        case 'Account':
          return this.defaultData('22', '22');
        case 'FAQ':
          return this.defaultData('22', '22');
        case 'Facebook':
          return this.defaultData('39', '39');
        case 'Linkedin':
          return this.defaultData('39', '39');
        case 'Instagram':
          return this.defaultData('39', '39');
        case 'Youtube':
          return this.defaultData('39', '39');
        case 'Web':
          return this.defaultData('19', '19');
        case 'Cellphone':
          return this.defaultData('13', '13');
        case 'LogoUpcitiesWhite':
          return this.defaultData('68', '19');
        case 'Email':
          return this.defaultData('16', '11');
        case 'BarCode':
          return this.defaultData('44', '44');
        case 'Book':
          return this.defaultData('44', '44');
        case 'Graphic':
          return this.defaultData('44', '44');
        case 'NovaReclamacaoBg':
          return this.defaultData('305', '71');
        case 'Clip':
          return this.defaultData('10', '16');
        case 'CircleClip':
          return this.defaultData('34', '34');
        case 'ConfirmData':
          return this.defaultData('34', '34');
        case 'CircleDocument':
          return this.defaultData('34', '34');
        case 'IcAdd':
          return this.defaultData('42', '42');
        case 'IcCheck':
          return this.defaultData('42', '42');
        case 'Trash':
          return this.defaultData('18', '20');
        case 'PdfImg':
          return this.defaultData('32', '42');
        case 'UserFinish':
          return this.defaultData('18', '20');
        case 'DocumentsFinish':
          return this.defaultData('20', '22');
        case 'ClipFinish':
          return this.defaultData('11', '18');
        case 'EyeSolid':
          return this.defaultData('17', '10');
        case 'Descricao':
          return this.defaultData('19', '22');
        case 'Download':
          return this.defaultData('18', '21');
        case 'Play':
          return this.defaultData('13', '18');
        case 'Pause':
          return this.defaultData('14', '18');
        case 'Dislike':
          return this.defaultData('38', '38');
        case 'Clock':
          return this.defaultData('16', '16');
        case 'Redirect':
          return this.defaultData('10', '10');
        case 'OnboardingAvatar':
          return this.defaultData('153', '148');
        case 'Balloon':
          return this.defaultData('26', '26');
        case 'IlustracaoErro':
          return this.defaultData('260', '249');
        case 'Compartilhar':
          return this.defaultData('24', '24');
        case 'Info':
          return this.defaultData('24', '24');
        case 'Imprimir':
          return this.defaultData('24', '24');
        case 'CopyLink':
          return this.defaultData('21', '20');
        case 'FacebookShare':
          return this.defaultData('7', '16');
        case 'WhatsappShare':
          return this.defaultData('16', '16');
        case 'TwitterShare':
          return this.defaultData('16', '13');
        case 'Backspace':
          return this.defaultData('24', '24');
        case 'Endereco':
          return this.defaultData('24', '24');
        case 'InformacoesAdicionais':
          return this.defaultData('24', '24');
        case 'Files':
          return this.defaultData('24', '24');
        case 'FormDescription':
          return this.defaultData('24', '24');
        case 'MultiFile':
          return this.defaultData('36', '45');
        case 'Copy':
          return this.defaultData('24', '24');
        case 'Confirm':
          return this.defaultData('60', '60');
        case 'ModalIllustrationError':
          return this.defaultData('99', '90');
        case 'IconEdit':
          return this.defaultData('18', '18');
        case 'IconId':
          return this.defaultData('18', '13.846');
        case 'IconMail':
          return this.defaultData('15', '12');
        case 'IconPhone':
          return this.defaultData('16.018', '16');
        case 'IconUser':
          return this.defaultData('14', '15');
        case 'WarningTriangle':
          return this.defaultData('81', '74');
        case 'FileDoc':
          return this.defaultData('40', '41');
        case 'FileImg':
          return this.defaultData('40', '41');
        case 'FileLimite':
          return this.defaultData('41', '49');
        case 'FilePdf':
          return this.defaultData('40', '41');
        case 'Mais':
          return this.defaultData('10', '10');
        case 'Comentar':
          return this.defaultData('26.5', '24');
        case 'DadosSolicitacao':
          return this.defaultData('22.6', '20');
        case 'HistoricoAnexos':
          return this.defaultData('24', '22');
        case 'Detalhes':
          return this.defaultData('17', '10');
        case 'Excluir':
          return this.defaultData('22', '24');
        case 'LockSolid':
          return this.defaultData('19', '24');
        case 'Feedback':
          return this.defaultData('20', '20');
        case 'SurveyLogo':
          return this.defaultData('244', '100');
        case 'RatingStar':
          return this.defaultData('36', '36');
        case 'Represented':
          return this.defaultData('24', '24');
        default:
          return this.defaultData('200');
      }
    },
  },
  methods: {
    defaultData(width, height = null, viewBox = null) {
      return {
        name: this.name ? this.name : this.icon,
        width: this.width ? this.width : width,
        height: this.height ? this.height : (height || width),
        viewBox: this.viewBox ? this.viewBox : (viewBox || `0 0 ${width} ${(height || width)}`),
      };
    },
  },
};
</script>
